import { AvInput, AvGroup, AvFeedback } from 'availity-reactstrap-validation'
import { Label } from 'reactstrap'

export default ({ name, required = false, label, html, error }) => (
  <AvGroup className="group accept" check>
    <AvInput
      id={name}
      type="checkbox"
      name={name}
      required={required}
    />
    {
      html ?
        <Label
          check
          for={name}
          className="accept-text"
          dangerouslySetInnerHTML={{ __html: html }}
        />
        :
        <Label
          check
          for={name}
          className="accept-text"
        >
          {label}
        </Label>
    }
    <AvFeedback className="form-input-error">{error}</AvFeedback>
  </AvGroup>
)



// WEBPACK FOOTER //
// src/components/AvCustomCheckbox.js